import React from "react";
import dynamic from "next/dynamic";
import { useSelector } from "react-redux";
import shouldLoadDyna from "@gc-npm/core.utils.should-load-dyna";
import RouteHandler from "@gc-npm/core.route-handler";
import Saam from "@gc-npm/core.scripts.saam";
import OneTrust from "@gc-npm/components.one-trust-x";
import ErrorBoundary from "@/component/error-boundary";
import { wrapper } from "store";
import "@/styles/globals.scss";
import "@/styles/fonts.scss";
import "@/styles/colors.scss";
import "@/styles/grid.scss";
import "@/layouts/mixin-styles.scss";
import "@/styles/card.scss";

const Dyna = dynamic(() => import("@gc-npm/core.scripts.dyna"));

const App = ({ Component, pageProps }) => {
  const Modal = useSelector((state) => state.modals.Modal);
  return (
    <>
      <RouteHandler />
      <ErrorBoundary>
        <Component {...pageProps} />
        {Modal && Modal}
        <OneTrust />
      </ErrorBoundary>
      <Saam />
      {shouldLoadDyna() && <Dyna />}
      {/* APP DELIMITER */}
    </>
  );
};

export default wrapper.withRedux(App);
